module.exports = __webpack_public_path__ + "img/characteristic-2.30b37372.png";